import { Controller, Control, Path } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';

import { DropdownOption } from '../DropDown';

import { HospitalUserFormValues } from '@src/pages/hospital-user-edit/hooks/useHospitalUserForm';

interface Props {
  fieldName: Path<HospitalUserFormValues>;
  control: Control<HospitalUserFormValues>;
  readOnly?: boolean;
  fieldClassName?: string;
  readOnlySx?: object;
  professionalBodiesList: DropdownOption[];
}

function ControlledProfessionalBodiesAutoComplete({
  fieldName,
  control,
  readOnly = false,
  fieldClassName,
  readOnlySx,
  professionalBodiesList,
}: Props) {
  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { onChange, value } }) =>
        readOnly ? (
          <TextField
            fullWidth
            label="Professional Body"
            value={
              professionalBodiesList.find((opt) => opt.id === value)?.name ?? ''
            }
            InputProps={{ readOnly: true }}
            className={fieldClassName}
            sx={readOnlySx}
            InputLabelProps={{ shrink: true }}
          />
        ) : (
          <Autocomplete
            options={professionalBodiesList}
            freeSolo={false}
            getOptionLabel={(option) => option.name}
            value={
              professionalBodiesList.find((opt) => opt.id === value) || null
            }
            onChange={(_, newValue) => {
              onChange(newValue ? newValue.id : null);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Professional Body" />
            )}
          />
        )
      }
    />
  );
}

export default ControlledProfessionalBodiesAutoComplete;
